import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=cddc99f0&scoped=true&"
import script from "./menu.js?vue&type=script&lang=js&"
export * from "./menu.js?vue&type=script&lang=js&"
import style0 from "./global.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "./menu.scss?vue&type=style&index=1&id=cddc99f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddc99f0",
  null
  
)

export default component.exports